import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import IconMarcador from "../../assets/iconos/marcador.png"

const containerStyle = {
  width: "100%",
  height: "50vh",
  margin: "8px 0px 8px 0px ",
};

const MapaRegistroPropiedad = ({
  ubicacion,
  getLatitud,
  getLongitud,
  latitud,
  longitud,
}) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const coordsArequipa = { lat: -16.398694704816343, lng: -71.53695703436338 };
  const coordsChiclayo = { lat: -6.771579, lng: -79.838595 };
  const coordsCuzco = { lat: -13.51656, lng: -71.97813 };
  const coordsHuancayo = { lat: -12.06799659488013, lng: -75.21004309500957 };
  const coordsIca = { lat: -14.064101, lng: -75.728999 };
  const coordsLima = { lat: -12.046009, lng: -77.030538 };
  const coordsMoquegua = { lat: -17.193877, lng: -70.934478 };
  const coordsPiura = { lat: -5.197167201394463, lng: -80.62664614668523 };
  const coordsPuno = { lat: -15.84054473927132, lng: -70.0276914112913 };
  const coordsTrujillo = { lat: -8.111842805587816, lng: -79.02864354551397 };
 
  const coordsEscritas = { lat: Number(latitud), lng: Number(longitud) };

  const [map, setMap] = useState(null);
  const [center, setCenter] = useState({ lat: 0, lng: 0 });

  //*************modificacion del centro del mapa de acuerdo a ubicacion e inputs************/
  useEffect(() => {
    if (ubicacion == "Arequipa") {
      setCenter(coordsArequipa);
    } else if (ubicacion == "Chiclayo") {
      setCenter(coordsChiclayo);
    } else if (ubicacion == "Cuzco") {
      setCenter(coordsCuzco);
    } else if (ubicacion == "Huancayo") {
      setCenter(coordsHuancayo);
    } else if (ubicacion == "Ica") {
      setCenter(coordsIca);
    } else if (ubicacion == "Lima") {
      setCenter(coordsLima);
    } else if (ubicacion == "Moquegua") {
      setCenter(coordsMoquegua);
    } else if (ubicacion == "Piura") {
      setCenter(coordsPiura);
    } else if (ubicacion == "Puno") {
      setCenter(coordsPuno);
    } else if (ubicacion == "Trujillo") {
      setCenter(coordsTrujillo);
    }
  }, [ubicacion]);

  useEffect(() => {
    setCenter(coordsEscritas);
  }, [latitud, longitud]);

  //*******************montar, desmontar el mapa y tipo de desplazamiento(pan)****************/
  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);
  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  useEffect(() => {
    if (map) {
      const newCenter = new window.google.maps.LatLng(center.lat, center.lng);
      map.panTo(newCenter);
    }
  }, [map, coordsEscritas]);

  //**********************modifica el centro del mapa al hacer click en mapa****************** */
  const manejarMapClick = (e) => {
    const clickedLocation = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    getLatitud(clickedLocation.lat);
    getLongitud(clickedLocation.lng);
    setCenter(clickedLocation);
  };

  //*************************************renderizacion del mapa****************************** */
  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={14}
      onLoad={onLoad}
      onUnmount={onUnmount}
      onClick={manejarMapClick}
      options={{clickableIcons: false, gestureHandling: "greedy",}}
    >
      <Marker 
       position={center} 
       map={map} 
       icon={{url: IconMarcador, scaledSize: new window.google.maps.Size(40, 50),}}
      />
    </GoogleMap>
  ) : (
    <></>
  );
};

export default MapaRegistroPropiedad;
